module.exports = __webpack_public_path__ + "img/sable-loading.0513f834.svg";